import { render, staticRenderFns } from "./OToaster.vue?vue&type=template&id=5f538677&"
import script from "./OToaster.vue?vue&type=script&lang=js&"
export * from "./OToaster.vue?vue&type=script&lang=js&"
import style0 from "./OToaster.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports